import { z } from "zod";
import { PreReviewDocumentSchema } from "../treezor/index.js";

export default {
  params: z.object({
    accountId: z.string(),
    userId: z.number().int(),
    documentId: z.string(),
    comment: z.string(),
    status: z.enum(["VALIDATED", "REFUSED"]),
  }),
  response: PreReviewDocumentSchema,
};
